import { dailyRentalSlice } from "components/store/reducers/reservation/reservationReducer";

export const { updateReservation, resetReservation } = dailyRentalSlice.actions;
